import { render } from "./VatGroupList.vue?vue&type=template&id=5146bed2"
import script from "./VatGroupList.vue?vue&type=script&lang=js"
export * from "./VatGroupList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__